import styled from 'styled-components';

//components
import $ElementResizeListener from 'components/ElementResizeListener';
import $Picture from 'components/Picture';

export const ContainerWithConstantAspectRatio = styled.div`
  position: relative;
  width: 100%;
`;

export const ContainerWithVariableAspectRatio = styled(
  ContainerWithConstantAspectRatio.withComponent($ElementResizeListener)
)`
  height: 100%;
`;

export const StyledPicture = styled($Picture)`
  height: 100%;
  width: 100%;

  ${p =>
    p.shouldBeAbsolutelyPositioned &&
    `
    left: 0;
    position: absolute;
    top: 0;
  `}
`;
